import _slugify from 'slugify'

const slugify = (s) => _slugify((s || '').toLowerCase(), { remove: /[:!?',$%<>"]/gm })

export default slugify
